var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFeedEmptystate = function SvgFeedEmptystate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.132 89.839c7.19.2 14.381.32 21.572.36 1.488.008 2.692-1.215 2.689-2.727-.018-7.3-.03-14.599-.033-21.898a2.74 2.74 0 0 0-2.738-2.739c-7.3-.004-14.6-.014-21.899-.032-1.512-.003-2.734 1.2-2.726 2.689.04 7.19.16 14.38.36 21.571.042 1.489 1.287 2.734 2.775 2.776Z",
    fill: "url(#feed-emptystate_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.997 65.492c.04 7.19.16 14.381.36 21.572.042 1.488 1.287 2.733 2.775 2.775 7.19.2 14.38.32 21.571.36-11.16-4.432-20.275-13.546-24.706-24.707Z",
    fill: "url(#feed-emptystate_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.723 57.395c7.3-.018 14.599-.029 21.898-.032a2.74 2.74 0 0 0 2.739-2.739c.003-7.3.014-14.599.033-21.898.003-1.512-1.201-2.735-2.69-2.726-7.19.04-14.38.16-21.571.36-1.488.041-2.733 1.286-2.775 2.774-.2 7.19-.32 14.381-.36 21.572-.009 1.488 1.214 2.692 2.726 2.69Z",
    fill: "url(#feed-emptystate_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.357 33.135c-.2 7.19-.32 14.38-.36 21.571-.008 1.489 1.214 2.692 2.726 2.69 7.3-.019 14.6-.03 21.899-.033-11.322-4.364-20.276-13.21-24.265-24.228Z",
    fill: "url(#feed-emptystate_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.49 90.198c7.19-.04 14.38-.16 21.571-.36 1.489-.041 2.733-1.286 2.775-2.774.2-7.19.32-14.381.36-21.572.009-1.488-1.214-2.692-2.726-2.689-7.3.018-14.599.029-21.899.033a2.74 2.74 0 0 0-2.738 2.738c-.003 7.3-.014 14.6-.033 21.899-.002 1.511 1.201 2.734 2.69 2.725Z",
    fill: "url(#feed-emptystate_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.833 65.574c-.003 7.3-.014 14.599-.033 21.898-.003 1.512 1.201 2.735 2.69 2.726 7.19-.04 14.38-.16 21.571-.36-11.018-3.989-19.863-12.943-24.228-24.264Z",
    fill: "url(#feed-emptystate_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.571 57.363c7.3.004 14.6.015 21.899.033 1.511.003 2.734-1.2 2.726-2.69a969.86 969.86 0 0 0-.36-21.57c-.042-1.49-1.287-2.734-2.775-2.776-7.19-.2-14.38-.32-21.572-.36-1.488-.008-2.692 1.215-2.689 2.727.019 7.3.03 14.599.033 21.898a2.74 2.74 0 0 0 2.738 2.738Z",
    fill: "url(#feed-emptystate_svg__g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8 32.726c.019 7.3.03 14.6.033 21.899a2.74 2.74 0 0 0 2.738 2.738c7.3.004 14.6.015 21.899.033a42.8 42.8 0 0 1-24.67-24.67Z",
    fill: "url(#feed-emptystate_svg__h)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "feed-emptystate_svg__a",
    x1: 55.954,
    y1: 63.563,
    x2: 16.068,
    y2: 102.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "feed-emptystate_svg__b",
    x1: 46.094,
    y1: 77.857,
    x2: 21.775,
    y2: 95.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "feed-emptystate_svg__c",
    x1: 55.953,
    y1: 30.76,
    x2: 16.068,
    y2: 69.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "feed-emptystate_svg__d",
    x1: 46.041,
    y1: 45.276,
    x2: 22.055,
    y2: 63.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "feed-emptystate_svg__e",
    x1: 88.757,
    y1: 63.564,
    x2: 48.872,
    y2: 102.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "feed-emptystate_svg__f",
    x1: 78.608,
    y1: 77.897,
    x2: 54.48,
    y2: 95.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "feed-emptystate_svg__g",
    x1: 88.757,
    y1: 30.761,
    x2: 48.871,
    y2: 69.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "feed-emptystate_svg__h",
    x1: 78.874,
    y1: 45.072,
    x2: 54.591,
    y2: 62.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869
  })))));
};

export default SvgFeedEmptystate;